import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import Account from 'developer-experience-shared-components/accounts/models/Account';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RequestStatusPropType } from '../data/models/RequestStatus';
import { getAuthorizationDataStatus, getAuthorizeApplicationErrorCode, getAuthorizeApplicationErrorSubCategory } from '../selectors/AppSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
/** To show a warning before selection that only enterprise HubSpot accounts
 * can install this app
 * @param providerName name of the application (e.g. Okta SCIM)
 */
const EnterpriseOnlyWarning = ({
  providerName
}) => /*#__PURE__*/_jsx(UIAlert, {
  className: "m-y-4 m-x-3 p-y-4",
  type: "warning",
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "oauth.authorization.enterpriseOnly.warning",
    options: {
      providerName
    }
  })
});

/** To show a error after failed account authorization that only enterprise
 * HubSpot accounts can install this app
 * @param providerName name of the application (e.g. Okta SCIM)
 */
const EnterpriseOnlyError = ({
  providerName
}) => /*#__PURE__*/_jsx(UIAlert, {
  className: "m-y-4 m-x-3 p-y-4",
  type: "danger",
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "oauth.authorization.enterpriseOnly.error.title",
    options: {
      providerName
    }
  }),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "oauth.authorization.enterpriseOnly.error.body"
  })
});
const EnterpriseOnlyAlert = ({
  location,
  providerName,
  authorizationDataStatus,
  authorizeApplicationErrorCode,
  authorizeApplicationErrorSubCategory,
  selectedAccount
}) => {
  const [showError, setShowError] = useState(false);
  useEffect(() => {
    if (authorizationDataStatus.pending || authorizationDataStatus.uninitialized) {
      return;
    } else if (authorizationDataStatus.warning && (authorizeApplicationErrorCode === 'HUB_UNAUTHORIZED' || authorizeApplicationErrorSubCategory === 'AuthorizationErrorType.PORTAL_UNAUTHORIZED')) {
      setShowError(true);
      return;
    } else {
      window.location.href = `${selectedAccount.get('appDomain')}/oauth/${selectedAccount.get('id')}/authorize${location.search}`;
    }
  }, [setShowError, authorizationDataStatus, authorizeApplicationErrorCode, authorizeApplicationErrorSubCategory, selectedAccount, location]);
  return /*#__PURE__*/_jsx("div", {
    style: {
      maxWidth: '720px'
    },
    children: showError ? /*#__PURE__*/_jsx(EnterpriseOnlyError, {
      providerName: providerName
    }) : /*#__PURE__*/_jsx(EnterpriseOnlyWarning, {
      providerName: providerName
    })
  });
};
EnterpriseOnlyAlert.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired,
  providerName: PropTypes.string.isRequired,
  authorizationDataStatus: RequestStatusPropType.isRequired,
  authorizeApplicationErrorCode: PropTypes.string,
  authorizeApplicationErrorSubCategory: PropTypes.string,
  selectedAccount: PropTypes.instanceOf(Account).isRequired
};

// @ts-expect-error Replace type of state once root reducer is typed
const mapStateToProps = state => ({
  authorizationDataStatus: getAuthorizationDataStatus(state),
  authorizeApplicationErrorCode: getAuthorizeApplicationErrorCode(state),
  authorizeApplicationErrorSubCategory: getAuthorizeApplicationErrorSubCategory(state)
});
export default compose(withRouter, connect(mapStateToProps))(EnterpriseOnlyAlert);